import firebase from "../../firebase";

export default function({ name }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "user",
        funcName: "createOffice",
        data: { name }
    });
}
